// extracted by mini-css-extract-plugin
export default {"nodeText":"nodeText-index-CytMY"};